<micro-lookup domain="auth" obj="applications" url="/applications" [key]="applicationId" [link]="link"></micro-lookup>
